import React from 'react';

import TagsLoader from './TagsLoader';
import Stack from '../../Shared/UI/Stack/components/Stack';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import TagsTable from './TagsTable';
import TagsPageController from './TagsPageController';
import TagsFeedback from './TagsFeedback';

import styles from './Tags.module.scss';

const Tags = () => {
  return (
    <>
      <TagsLoader />
      <div className={styles.pageLayout}>
        <Stack gap="lg">
          <PageTitle text={'Tags'} />
          <TagsTable />
          <TagsPageController />
        </Stack>
      </div>
      <TagsFeedback />
    </>
  );
};

export default Tags;
